import React, { useState, useEffect } from 'react';
import './AccountModal.scss';
import Spinner from '../../../Spinner.js';
import Pool from '../../../../UserPool.js';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import VerificationInput from "react-verification-input";
import axios from 'axios';

export default function UpdateEmail(props) {
    const { 
      setModal, 
      user, 
      setEmail
    } = props;

    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [error, setError] = useState(false);
    const [newEmail, setNewEmail] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [showVerification, setShowVerification] = useState(false);

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const updateEmailHelper = (newEmail) => {
        return new Promise((resolve, reject) => {
          const poolUser = Pool.getCurrentUser();
      
          if (!poolUser) {
            return reject(new Error("user not logged in."));
          }
      
          poolUser.getSession((err, session) => {
            if (err) {
              return reject(err);
            }
      
            const attributeList = [
              new CognitoUserAttribute({
                Name: 'email',
                Value: newEmail,
              }),
            ];
      
            poolUser.updateAttributes(attributeList, (err, result) => {
              if (err) {
                return reject(err);
              }
      
              resolve(result);
            });
          });
        });
    };

    const updateEmail = () => {
        setLoading(true);
        setError(false);
        if (!isValidEmail(newEmail)) {
            setLoading(false);
            setError('Please provide a valid email.')
        } else {
            updateEmailHelper(newEmail)
            .then(() => {
                setLoading(false);
                setShowVerification(true);
                setSuccessMessage('You must confirm new email through the verification code sent to your email.');
                }).catch(err => {
                    console.log('error updating email');
                    setLoading(false);
                    setError(err.message);
            });
        }
    }

    const verifyEmailHelper = (verificationCode) => {
        setLoading(true);
        return new Promise((resolve, reject) => {
          const poolUser = Pool.getCurrentUser();
      
          if (!poolUser) {
            return reject(new Error("user not logged in."));
          }
      
          poolUser.getSession((err, session) => {
            if (err) {
              return reject(err);
            }
      
            poolUser.verifyAttribute('email', verificationCode, {
              onSuccess: (result) => {
                resolve(result);
                setShowVerification(false);
                axios.get(`https://firewatch-api.space-eyes.com/user/update-email?newEmail=${newEmail}`, {
                  headers: {
                    'Authorization': `Bearer ${user.idToken.jwtToken}`
                  }
                }).then((response) => {
                  setLoading(false);
                  console.log('success updating email');
                  setSuccessMessage('Email updated successfully.');
                  setEmail(newEmail);
                  setModal({
                    type: false,
                    content: null
                  })
                }).catch((err) => {
                  setLoading(false);
                  setError(`Trouble confirming account. Please try again. ${err}`);
                })
              },
              onFailure: (err) => {
                setLoading(false);
                setError(`Trouble verifying account. Please try again. ${err}`)
                reject(err);
                return;
              },
            });
          });
        });
    };

    useEffect(() => {
        if (verificationCode.length === 6) {
            verifyEmailHelper(verificationCode);
        }
    }, [verificationCode]);

    return (
      <div className='account-modal'>
          <div className='account-modal-title'>Updating Email</div>
              <div className='account-modal-content-inputs'>
                  {showVerification ?
                  <div className='account-modal-content-verification-container'>
                    <div className='account-modal-content-verification-container-text'>{`Enter 6-digit code sent to ${newEmail}.`}</div>
                    <VerificationInput
                      placeholder=''
                      autoFocus={true}
                      onChange={(e) => setVerificationCode(e)}
                    />
                  </div>
                  :
                  <div className='account-modal-content-inputs-input-container'>
                      <div className='account-modal-content-inputs-input-container-title'>New Email</div>
                      <input
                          placeholder='johnsmith@email.com'
                          type='text' 
                          className='account-modal-content-inputs-input-container-input'
                          value={newEmail}
                          onChange={(e) => setNewEmail(e.target.value)}
                      />
                  </div>}
              </div>
          {error && <div className='account-modal-content-error'>{error}</div>}
          {loading ?
          <div style={{ paddingTop: '1rem' }}>
            <Spinner />
          </div>
          :
          <div className='account-modal-bottom-btns'>
              <div 
                  className='account-modal-bottom-btns-btn-cancel'
                  onClick={() => {
                      setModal({
                          type: false,
                          content: null
                      })
                  }}>
                  Cancel
              </div>
              <button 
                  className='account-modal-bottom-btns-btn-save'
                  disabled={!isValidEmail(newEmail)}
                  style={!isValidEmail(newEmail) ? { cursor: 'not-allowed', background: 'gray' } :  { } }
                  onClick={updateEmail}
                  >
                  Save Changes
              </button>
          </div>}
      </div>
    )
}